//这里是 产品管理 模块的路由文件

const basePath = "/admin/product/"
export default [
    // 产品列表
    {
        path: `${basePath}list`,
        name: 'ProductList',
        component: r => require.ensure([], () => r(require('@/views/product/ProductList')), 'Product')
    },
    // 产品详情
    {
        path: `${basePath}description`,
        name: 'ProductDescription',
        component: r => require.ensure([], () => r(require('@/views/product/ProductDescription')), 'Product')
    },
    // 产品创建
    {
        path: `${basePath}create`,
        name: 'ProductCreate',
        component: r => require.ensure([], () => r(require('@/views/product/ProductCreate')), 'Product')
    },
    // 设备清单  (原名: 产品机器)
    {
        path: `${basePath}machine`,
        name: 'ProductMachine',
        component: r => require.ensure([], () => r(require('@/views/product/ProductMachine')), 'Product')
    }
]
